/* eslint-disable eqeqeq */
import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputCNPJ(props) {
	let _inputCNPJ = React.createRef();

	// https://www.geradorcnpj.com/javascript-validar-cnpj.htm
	const validarCNPJ = cnpj => {
		cnpj = cnpj.replace(/[^\d]+/g, '');

		if (cnpj == '') return false;

		if (cnpj.length != 14) return false;

		// Elimina CNPJs invalidos conhecidos
		if (
			cnpj == '00000000000000' ||
			cnpj == '11111111111111' ||
			cnpj == '22222222222222' ||
			cnpj == '33333333333333' ||
			cnpj == '44444444444444' ||
			cnpj == '55555555555555' ||
			cnpj == '66666666666666' ||
			cnpj == '77777777777777' ||
			cnpj == '88888888888888' ||
			cnpj == '99999999999999'
		)
			return false;

		// Valida DVs
		let tamanho = cnpj.length - 2;
		let numeros = cnpj.substring(0, tamanho);
		let digitos = cnpj.substring(tamanho);
		let soma = 0;
		let pos = tamanho - 7;
		let i = 0;
		for (let i = tamanho; i >= 1; i--) {
			soma += numeros.charAt(tamanho - i) * pos--;
			if (pos < 2) pos = 9;
		}
		let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
		if (resultado != digitos.charAt(0)) return false;

		tamanho = tamanho + 1;
		numeros = cnpj.substring(0, tamanho);
		soma = 0;
		pos = tamanho - 7;
		for (i = tamanho; i >= 1; i--) {
			soma += numeros.charAt(tamanho - i) * pos--;
			if (pos < 2) pos = 9;
		}
		resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
		if (resultado != digitos.charAt(1)) return false;

		return true;
	};

	const handleBlur = evt => {
		validate(evt).then(e => {
			if (typeof props.onBlur === 'function') {
				props.onBlur(e);
			}
		});
	};

	const handleChange = evt => {
		validate(evt).then(e => {
			if (typeof props.onChange === 'function') {
				props.onChange(e);
			}
		});
	};

	const validate = evt =>
		new Promise(resolve => {
			const inputDOMNode = _inputCNPJ.current.getInputDOMNode();
			const valid = !evt.target.value.includes('_') && validarCNPJ(evt.target.value);
			if (!valid) {
				inputDOMNode.setCustomValidity('Digite o CNPJ corretamente.');
			} else {
				inputDOMNode.setCustomValidity('');
			}
			resolve({
				...evt,
				target: {
					...evt.target,
					type: evt.target.type,
					required: evt.target.required,
					name: evt.target.name,
					validity: {
						...evt.target.validity,
						valid: valid,
					},
				},
			});
		});

	return (
		<InputMask
			ref={_inputCNPJ}
			value={props.value}
			type="text"
			id="cnpj"
			name="cnpj"
			mask="99.999.999/9999-99"
			maskChar="_"
			onBlur={handleBlur}
			onChange={handleChange}
			required={props.required}
			pattern="[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}"
			className={`form-control ${props.invalid && 'is-invalid'}`}
		/>
	);
}

InputCNPJ.propTypes = {
	onBlur: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	required: PropTypes.bool,
	invalid: PropTypes.bool,
	disabled: PropTypes.bool,
	className: PropTypes.string,
};
